import Utils from '@/lin/util/util'
import adminConfig from './admin'
import businessConfig from './business'
import receivableConfig from './receivable'
import centralRegistryConfig from './central-registry'
import bankConfig from './bank'

// eslint-disable-next-line import/no-mutable-exports
let homeRouter = [
  {
    title: '工作台',
    type: 'view',
    name: Symbol('dashboard'),
    route: '/dashboard',
    filePath: 'view/dashboard/dashboard.vue',
    inNav: true,
    icon: 'iconfont icon-iconset0103',
    isElementIcon: false,
    order: 1,
    // 工作台会根据用户角色动态显示不同内容，所有角色都可以访问
  },
  {
    title: '日志管理',
    type: 'view',
    name: Symbol('log'),
    route: '/log',
    filePath: 'view/log/log.vue',
    inNav: true,
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
    order: 2,
    permission: ['查询所有日志'],
  },
  {
    title: '404',
    type: 'view',
    name: Symbol('404'),
    route: '/404',
    filePath: 'view/error-page/404.vue',
    inNav: false,
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
  },
  {
    title: '个人中心',
    type: 'view',
    name: Symbol('profile'),
    route: '/center',
    filePath: 'view/center/center.vue',
    inNav: false,
    icon: 'iconfont icon-user',
    isElementIcon: false,
    order: 100,
  },
  businessConfig,
  receivableConfig,
  centralRegistryConfig,
  bankConfig,
  adminConfig,
]

// 处理顺序
homeRouter = Utils.sortByOrder(homeRouter)
deepReduceName(homeRouter)

export default homeRouter


/**
 * 使用 Symbol 处理 name 字段, 保证唯一性
 */
function deepReduceName(target) {
  if (Array.isArray(target)) {
    target.forEach(item => {
      if (typeof item !== 'object') {
        return
      }
      deepReduceName(item)
    })
    return
  }
  if (typeof target === 'object') {
    if (typeof target.name !== 'symbol') {
      target.name = target.name || Utils.getRandomStr()
      target.name = Symbol(target.name)
    }

    if (Array.isArray(target.children)) {
      target.children.forEach(item => {
        if (typeof item !== 'object') {
          return
        }
        deepReduceName(item)
      })
    }
  }
}
